export const ANALYTICS_EVENT_TYPE_LOAD = 'load';
export const ANALYTICS_EVENT_TYPE_START = 'start';
export const ANALYTICS_EVENT_TYPE_COMPLETE = 'complete';

export const ANALYTICS_GROUP_BY_HOUR = 'hour';
export const ANALYTICS_GROUP_BY_DAY = 'day';
export const ANALYTICS_GROUP_BY_MONTH = 'month';
